import { toast } from "react-hot-toast";
import Swal from "sweetalert2";
import i18n from "i18n/config";
import arTranslations from "i18n/locales/ar/translations.json";
import enTranslations from "i18n/locales/en/translations.json";

// toast message
const AlertMessage = (message = "", type = "success", duration = 5000) => {
  const currentLanguage =
    (typeof window !== "undefined" && window.localStorage
      ? window.localStorage.getItem("lang") ||
        window.localStorage.getItem("i18nextLng")
      : null) ||
    i18n.resolvedLanguage ||
    i18n.language ||
    (typeof document !== "undefined" ? document.documentElement.lang : null) ||
    "en";

  const translationMap = currentLanguage === "ar" ? arTranslations : enTranslations;
  const translatedMessage =
    typeof message === "string"
      ? translationMap?.[message] ||
        i18n.t(message, {
          ns: "translations",
          lng: currentLanguage,
          defaultValue: message,
        })
      : message;
  if (type === "success") {
    toast.success(translatedMessage, { duration });
  } else if (type === "info") {
    toast(translatedMessage, { 
      duration,
      icon: 'ℹ️',
      style: {
        background: '#3b82f6',
        color: '#fff',
      },
    });
  } else {
    toast.error(translatedMessage, { duration });
  }
};

// confirmation dialog
const confirm = (message, confirmText, cancelText, onConfirm, onCancel) => {
  Swal.fire({
    title: message,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    reverseButtons: true,
  }).then((result) => {
    if (result.isConfirmed && typeof onConfirm === "function") {
      onConfirm();
    } else if (
      result.dismiss === Swal.DismissReason.cancel &&
      typeof onCancel === "function"
    ) {
      onCancel();
    }
  });
};

const AlertServices = {
  AlertMessage,
  confirm,
};

export default AlertServices;
